module.exports = __webpack_public_path__ + "img/zhanghao.f9445a99.png";